import type { ReactNode } from 'react';
import { Clock } from 'lucide-react';

interface Props {
  children: ReactNode;
  /** Длительность чтения краткого содержания. Передаётся через directive
   *  attribute: `:::tldr{minutes="2"}`. Может быть строкой (markdown attrs
   *  парсит атрибуты как строки). */
  minutes?: string | number;
}

export function TldrPill({ children, minutes }: Props) {
  const m = typeof minutes === 'string' ? Number(minutes) : minutes;
  return (
    <aside aria-label="Краткое содержание" className="my-8">
      <div className="mb-4 flex flex-wrap items-center gap-3">
        <div
          className="inline-block rounded-full bg-action-primary-bg px-3 py-1 text-xs font-medium uppercase tracking-wider text-text-on-brand"
          aria-hidden
        >
          Краткое содержание
        </div>
        {m !== undefined && !Number.isNaN(m) && (
          <span className="inline-flex items-center gap-1.5 text-sm text-text-secondary tabular-nums">
            <Clock className="h-3.5 w-3.5" aria-hidden />
            Можно прочитать за {m} мин
          </span>
        )}
      </div>
      <div className="space-y-3 text-sm leading-relaxed text-text-primary md:text-base">
        {children}
      </div>
    </aside>
  );
}
